import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c7606ede")

_pushScopeId("data-v-c7606ede")
const _hoisted_1 = /*#__PURE__*/_createVNode("use", { "xlink:href": "#iconzhongyingwen" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dropdown, null, {
      dropdown: _withId(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (item) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: item.value,
                disabled: _ctx.language===item.value
              }, {
                default: _withId(() => [
                  _createVNode("span", {
                    onClick: ($event: any) => (_ctx.handleSetLanguage(item.value))
                  }, _toDisplayString(item.name), 9, ["onClick"])
                ]),
                _: 2
              }, 1032, ["disabled"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        (_openBlock(), _createBlock("svg", {
          class: ["icon", {'svg-color': _ctx.isWhite}],
          "aria-hidden": "true",
          "font-size": "45px"
        }, [
          _hoisted_1
        ], 2))
      ]),
      _: 1
    })
  ]))
})